<template>
    <li @click="onClickHotRecommend(item.word)"><van-icon name="orders-o" size="1.2em"/>{{ item.word }}</li>
</template>

<script>
export default {
    props: ["item"],
    methods: {
        onClickHotRecommend(word){
            this.$emit("onClickHotRecommend",word);
        }
    },
};
</script>

<style></style>
